import { clearUser } from "@store/auth/userSlice";
import { setResellersData } from "@store/modules/accountManagement/resellersSlice";
import axios from "axios";

const handleUnauthorized = (dispatch, navigate) => {
	if (dispatch && navigate) {
		dispatch(clearUser());
		navigate("/login");
	} else {
		console.error("Dispatch or navigate function is missing.");
	}
};

export const fetchResellersData = async (
	token,
	dispatch,
	navigate,
	page,
	perPage,
	paginate = 1,
	searchTerms,
	store = true,
	signal = null,
) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
		params: {
			page: page,
			per_page: perPage,
			businessUnits: searchTerms?.businessUnits || null,
			distributor: searchTerms?.distributor || null,
			name: searchTerms?.name || null,
			paginate: paginate,
			type: 1,
		},
		signal: signal,
	};

	try {
		const response = await axios.get(`${import.meta.env.VITE_API_BACKEND}api/resellers`, config);

		let data;
		if (paginate === 1 && (!response.data.data || response.data.data.length === 0)) {
			data = {
				data: [],
				totalItems: 0,
				page: paginate === 1 ? page : 1,
				perPage: paginate === 1 ? perPage : 10,
			};
		} else {
			const totalItems = response.data?.total;
			data = {
				data: paginate === 1 ? response.data.data : response.data,
				totalItems: paginate === 1 ? totalItems : null,
				page: paginate === 1 ? page : 1,
				perPage: paginate === 1 ? perPage : 10,
			};
		}
		store && dispatch(setResellersData(data));
		return data;
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching Distributers data:", error);
		}
	}
};

export const createReseller = async (formData, token, dispatch, navigate) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "multipart/form-data",
		},
	};

	try {
		const response = await axios.post(
			`${import.meta.env.VITE_API_BACKEND}api/resellers`,
			formData,
			config,
		);
		return { status: response.status, data: response.data };
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else if (error.response && error.response.status === 422) {
			return { errors: error.response.data.errors };
		} else {
			console.error("Error creating reseller:", error);
		}
		return null;
	}
};

export const updateReseller = async (id, formData, token, dispatch, navigate) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "multipart/form-data",
		},
	};
	try {
		const response = await axios.post(
			`${import.meta.env.VITE_API_BACKEND}api/resellers/${id}`,
			formData,
			config,
		);
		return { status: response.status, data: response.data };
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else if (error.response && error.response.status === 422) {
			// Return the validation error from the response
			return { errors: error.response.data.errors };
		} else {
			console.error("Error updating client:", error);
		}
		return null;
	}
};

export const deleteResellerById = async (id, token, dispatch, navigate) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	try {
		const response = await axios.delete(
			`${import.meta.env.VITE_API_BACKEND}api/resellers/${id}`,
			config,
		);
		if (response.status === 200 || response.status === 202 || response.status === 204) {
			return {
				status: "success",
				message: "Reseller deleted successfully.",
			};
		} else {
			return {
				status: "error",
				message: response.data?.message || "An unexpected error occurred.",
			};
		}
	} catch (error) {
		if (error.response) {
			switch (error.response.status) {
				case 401:
					handleUnauthorized(dispatch, navigate);
					break;
				case 404:
					return { status: "not_found", message: "Not found." };
				case 405:
					return {
						status: "method_not_allowed",
						message: "Method Not Allowed",
					};
				case 400:
					return {
						status: "error",
						message: error.response.data?.message || "An error occurred.",
					};
				default:
					return { status: "error", message: "An error occurred." };
			}
		} else {
			return { status: "error", message: "Network error" };
		}
	}
};

export const getResellerById = async (id, token) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
			Accept: "*/*",
		},
	};

	try {
		const response = await axios.get(
			`${import.meta.env.VITE_API_BACKEND}api/resellers/${id}`,
			config,
		);
		return { status: response.status, data: response.data };
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching device info:", error);
			throw error;
		}
	}
};
export const getResellerPhotoById = async (id, token) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
			Accept: "*/*",
		},
		responseType: "blob",
	};

	try {
		const response = await axios.get(
			`${import.meta.env.VITE_API_BACKEND}api/resellers/${id}/download-photo`,
			config,
		);
		return { status: response.status, data: response.data };
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching device info:", error);
			throw error;
		}
	}
};
